import React, { useState, useEffect,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import '../Scss/_boarding.scss';
import { pageNavigationForBoardingModule, shortcutKeyForBoardingsPage, shortcutKeysBoarding, fncFocusElementDependsOnPathLocation } from '../Utility/CommonFun';
import { moduleAndLoginDivDisabled } from '../ReduxState';
import FocusLock from "react-focus-lock";

function Overview() {
    const ViewMenifestBtn = useRef(null);
    const tbodyRef = useRef(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const Location = useSelector(state => state.login.Location);
    const [triggerModal, settriggerModal] = useState(false);
    const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
    const flightTripBoarding = useSelector(state => state.flightSearch.flightTripBoarding);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
    const displayEconomymanifest = flightManifest && flightManifest.cabinPassengerCounts.filter(cc => cc.cabinOfService === 'Y');
    // console.log('displayEconomymanifest------', displayEconomymanifest);
    const filfoComments = flightTripBoarding.operationDetails.comments.length ?
    flightTripBoarding.operationDetails.comments.filter(c => c.type === 1) : [];
    const iropComments = flightTripBoarding.operationDetails.comments.length ?
    flightTripBoarding.operationDetails.comments.filter(c => c.type === 4) : [];
    const delayComments = flightTripBoarding.operationDetails.comments.length ?
    flightTripBoarding.operationDetails.comments.filter(c => c.type === 2) : [];
    const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
    const notify = (e) =>
    toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    useEffect(() => {
        document.addEventListener("keyup", function (event) {        
            if (event.key === "Enter") {
                const viewManifestButton = document.getElementById("viewManifest");            
                if (viewManifestButton && document.activeElement === viewManifestButton) {
                    viewManifestButton.click();
                }
            }            
        });
    });

    const goToManifest = () => {
        const navPage = pageNavigationForBoardingModule('Overview');
        history.push("/"+navPage); 
    }

    useEffect(() => {
        if (selectedLeg && flightManifest) {
            document.addEventListener("keydown", shortcutKeyHandler);
        }

        // cleanup this listener
        return () => {
            document.removeEventListener('keydown', shortcutKeyHandler);
        };
    }, [selectedLeg, flightManifest]);

    const shortcutKeyHandler = (e) => { 
        debugger
        if (e.key && shortcutKeysBoarding.includes(e.key)) {
            const path = shortcutKeyForBoardingsPage(location.pathname,e);
            if (path) {
                history.push('/' + path);    
            } 
        }
    }

    useEffect(()=>{
if(ViewMenifestBtn.current){
    ViewMenifestBtn.current.focus();
}
    },[])

    // update
    useEffect(() => {
        const handleKeyDown = (event) => {
             if (event.altKey && event.key.toLowerCase() === 'c') {
                        if(!IsModulAndLoginDivDisabled){
                            dispatch(moduleAndLoginDivDisabled({
                                type: "MODULE_AND_LOGINDIV_DISABLED",
                                IsModulAndLoginDivDisabled: true
                            }));
                            fncFocusElementDependsOnPathLocation(location.pathname,ViewMenifestBtn.current);
                        }else if (IsModulAndLoginDivDisabled) {
                                    const headingDiv = document.querySelector(".modulebtn");            
                                    if (headingDiv) {                  
                                        headingDiv.focus();
                                        dispatch(moduleAndLoginDivDisabled({
                                                type: "MODULE_AND_LOGINDIV_DISABLED",
                                                IsModulAndLoginDivDisabled: false
                                            }));
                                    }
                                }
                    }
            else if (event.shiftKey && event.key === "ArrowUp") {
                event.preventDefault(); // Prevents default scrolling behavior
                if (tbodyRef.current) {
                    tbodyRef.current.focus();
                }
            }
            if (event.shiftKey && event.key === "ArrowDown") {
                event.preventDefault(); // Prevents default scrolling behavior
                if (ViewMenifestBtn.current) {
                    ViewMenifestBtn.current.focus();
                }
                
            }
        };
    
        document.addEventListener("keydown", handleKeyDown);
    
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [IsModulAndLoginDivDisabled]);

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="full-container">
                <div class="boarding-container">
                    <div class="row">
                        <div class="col-lg-7 mt-3">
                            {/* <FocusLock> */}
                            <div class="card boarding-card fixedBtn">
                                <div class="heading mb-3 ">
                                    <h4 class="font-xxl bold dark-text mb-0">
                                        Overview <span class="font-lg regular">(Manifest Count)</span>
                                    </h4>
                                </div>
                                
                                <div class="searchTable OrangeShadow" ref={tbodyRef} tabIndex={-1} id='tableref'>
                                    <table 
                                    // id='tableref'
//  onKeyDown={handleKeyDown}            
                        >
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Manifest Count</th>
                                                <th>Economy Class (Y)</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>
                                                    Manifested
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].manifested : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].manifested : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>
                                                    Checked in
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].checkedIn : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].checkedIn : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>
                                                    No Show
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].noShow : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].noShow : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>
                                                    Stand-by
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].standBy : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].standBy : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>
                                                    Total Checked-In
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].totalCheckedIn : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].totalCheckedIn : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>
                                                    Thru Manifested
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruManifested : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruManifested : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>
                                                    Thru Checked In 
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruCheckedIn : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruCheckedIn : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>
                                                    Thru No Show
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruNoShow : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruNoShow : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>
                                                    Thru Stand-by
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruStandBy : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].thruStandBy : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>
                                                   Boarded
                                                </td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].totalOnBoard : ''}</td>
                                                <td>{displayEconomymanifest.length ? displayEconomymanifest[0].totalOnBoard : ''}</td>
                                            </tr>
                    
                                        </tbody>
                                    </table>
                                </div> 
                                <div class="btn-container justify-content-end d-flex">
                                    <button class="btn btn-primary SerachBtn" ref={ViewMenifestBtn} id='viewManifest' onClick={goToManifest}>
                                        <span class="px-4">View Manifest</span>
                                    </button>
                                </div>    
                            </div>
                            {/* </FocusLock> */}
                        </div>
                        <div class="col-lg-5 mt-3">
                            <div class="card boarding-card">
                                <div class="heading mb-3 ">
                                    <h4 class="font-xxl bold dark-text mb-0">
                                        Comments
                                    </h4>
                                </div>
                                <div class="comments-list">
                                    <div class="comment-list-item mb-3">
                                        <p class="font-md mb-0 primary-text bold">Flifo Comments <span class="dark-text regular font-sm">({filfoComments.length})</span></p>
                                        {
                                            filfoComments.length ? 
                                            filfoComments.map(item =>
                                                <ul class="list">
                                                    <li>
                                                        <p class="font-sm mb-0">{item.text}</p>
                                                    </li>
                                                </ul>
                                            ) : null
                                        }
                                    </div>
                                    <div class="comment-list-item mb-3">
                                        <p class="font-md mb-0 primary-text bold">IROP Comments <span class="dark-text regular font-sm">({iropComments.length})</span></p>
                                        {
                                            iropComments.length ? 
                                            iropComments.map(item =>
                                                <ul class="list">
                                                    <li>
                                                        <p class="font-sm mb-0">{item.text}</p>
                                                    </li>
                                                </ul>
                                            ) : null
                                        }
                                    </div>
                                    <div class="comment-list-item mb-3">
                                        <p class="font-md mb-0 primary-text bold">Delay Code & Comments <span class="dark-text regular font-sm">({delayComments.length})</span></p>
                                        {
                                            delayComments.length ? 
                                            delayComments.map(item =>
                                                <ul class="list">
                                                    <li>
                                                        <p class="font-sm mb-0">{item.text}</p>
                                                    </li>
                                                </ul>
                                            ) : null
                                        }
                                    </div>
                                    <div class="comment-list-item mb-3">
                                        <p class="font-md mb-0 primary-text bold">Weight & Balance Comments <span class="dark-text regular font-sm">(0)</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
       </div>
    );
}

export default Overview;